import { entityStore } from '~/utility/BinSentry-ui-utility';
import { useBnSnackbar } from '~/common/bn-snackbar-provider';

export async function downloadFile({ url, fileName, onError }) {
  try {
    const headers = new Headers({ Authorization: `Bearer ${(await entityStore.getToken())}` });
    const response = await fetch(url, { headers });

    if (!response.ok) {
      onError?.('Download failed');
      return;
    }
    await downloadBlobFile({ blob: response.body, fileName });
  } catch (err) {
    onError?.(err.message);
  }
}

export async function downloadBlobFile({ blob, fileName }) {
  const downloadUrl = URL.createObjectURL(await new Response(blob).blob());

  const ele = document.createElement('a');
  ele.style.display = 'none';
  ele.setAttribute('href', downloadUrl);
  ele.setAttribute('download', fileName);
  ele.click();
}

export function useFileDownloader({ url: staticUrl, fileName: staticFilename, onError } = {}) {
  const { enqueueSnackbar } = useBnSnackbar();
  const onErrorNormalized = onError || (message => enqueueSnackbar(message, { variant: 'error' }));
  return async ({ url: dynamicUrl, fileName: dynamicFilename } = {}) =>
    downloadFile({
      url: dynamicUrl || staticUrl,
      fileName: dynamicFilename || staticFilename,
      onError: onErrorNormalized,
    });
}
